import { render, staticRenderFns } from "./anwserDialog.vue?vue&type=template&id=734f2026&scoped=true"
import script from "./anwserDialog.vue?vue&type=script&lang=js"
export * from "./anwserDialog.vue?vue&type=script&lang=js"
import style0 from "./anwserDialog.vue?vue&type=style&index=0&id=734f2026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734f2026",
  null
  
)

export default component.exports